"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Hydrogen = void 0;
const react_1 = __importDefault(require("react"));
const hydrogen_1 = require("@geome/react-components-next/lib/components/hydrogen");
const hydrogen_2 = require("./icons/hydrogen");
const car_1 = require("./icons/car");
const van_1 = require("./icons/van");
const truck_1 = require("./icons/truck");
const bus_1 = require("./icons/bus");
const sectionWithTitle_1 = require("@geome/react-components-next/lib/components/sectionWithTitle");
const react_next_1 = require("@geome/react-next");
const Hydrogen = ({ location }) => {
    const { translate } = (0, react_next_1.useI18n)();
    if (!location.hydrogen_offering)
        return (react_1.default.createElement(sectionWithTitle_1.SectionWithTitle, { sectionTokenPath: "station_page.sections.hydrogen", id: "hydrogen", renderIcon: () => react_1.default.createElement(hydrogen_2.HydrogenIcon, null) }, translate("station_page.sections.hydrogen.unavailable")));
    return (react_1.default.createElement(hydrogen_1.Hydrogen, { configPath: "station_page.", sectionName: "hydrogen", hydrogenOffering: location.hydrogen_offering, sectionProps: { renderIcon: () => react_1.default.createElement(hydrogen_2.HydrogenIcon, null) }, supportedVehicleIcons: {
            car: react_1.default.createElement(car_1.CarIcon, null),
            van: react_1.default.createElement(van_1.VanIcon, null),
            truck: react_1.default.createElement(truck_1.TruckIcon, null),
            bus: react_1.default.createElement(bus_1.BusIcon, null),
        } }));
};
exports.Hydrogen = Hydrogen;
